<template>
  <div class="page_content explore_entity_inside my_program_status program program_guide__my_progress" aria-label="my program status">
    <div class="row page-heading">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
        <span class="module_icon icon-list"></span>
        <label v-if="formattedProgramGuide && formattedProgramGuide.title" id="programGuideTitle" class="head_txt module_type_name ace_sec_hd" :aria-label="formattedProgramGuide.title">
          {{formattedProgramGuide.title}}
        </label>
      </div>

      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 btn_container">
        <b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
          <span class="btn_ic ic-back"></span>
          <span class="btn_txt">{{deCamelCase()}}</span>
        </b-btn>
      </div>
    </div>


    <div class="page_content_container">
      <div v-if="formattedProgramGuide && formattedProgramGuide.title">
        <program-guide-menu
          :cipCode="formattedProgramGuide.cipCode"
          :programGuideCode="formattedProgramGuide.code"
          :type="formattedProgramGuide.type"
          :returnTo="returnTo"
          :active="'programStatus'">
        </program-guide-menu>
      </div>

      <div class="pg_content">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
          <div class="row pg_sec">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" v-if="!transactionValidity.transactionValid">
              <div class="row alert_msg_sec renew_service">
                <div class="col-8 msg_container">
                  <span v-html="transactionValidity.institutionPurchaseExpirationMessage"></span>
                </div>
                <div class="col-4 btn_container align-middle" v-if="!transactionValidity.programSwitched && !transactionValidity.inactive">
                  <b-btn @click="navigateToSelectedProgram()">Renew</b-btn>
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" v-if="transactionValidity.transactionValid && userObject.suspended">
              <div class="row alert_msg_sec renew_service">
                <div class="col-12 msg_container">
                  <span v-html="institution.userSuspensionMessage">
                  </span>
                </div>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 hd ace_sec_hd">
              <div class="score_sec">
                <div class="label">
                  {{ $tf('score') }}
                </div>
                <div class="progress_block">
                  <span class="state" :class="statusClass(score,formattedProgramGuide.hideScoreForStudent)" style="height: 35px; width: 70px;">
                    <span v-if="(isScoreNotAvailable || formattedProgramGuide.hideScoreForStudent)" class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
                    <span v-else class="progress_val ace_sec_txt" style="font-size: 15px;">{{score}}%</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="row">
                <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12">
                  <div class="sub_hd">
                    {{ $tf('academicProgress') }} 
                  </div>
                </div>
                <div class="col-xl-7 col-lg-7 col-md-7 col-sm-12">
                  <div class="progress-row" v-if="showCourseProgress()">
                    <div class="progress-bar-label"></div>
                    <b-progress :max="totalCourses">
                      <b-progress-bar :value="completedCourses" :title="showBarTitle(completedCourses, 'completed')" class="prog_bar__completed" v-b-tooltip.hover> {{completedCourses}} </b-progress-bar>
                      <b-progress-bar :value="inprogressCourses" :title="showBarTitle(inprogressCourses, 'in-progress')" class="prog_bar__in_progress" v-b-tooltip.hover> {{inprogressCourses}} </b-progress-bar>
                      <b-progress-bar :value="notStartedCourses" :title="showBarTitle(notStartedCourses, 'not started')" class="prog_bar__not_started" v-b-tooltip.hover> {{notStartedCourses}} </b-progress-bar>
                    </b-progress>
                  </div>
                  <div class="progress-row" v-else>
                    <div class="progress-bar-label">{{childrenCompleteCount}} of {{childrenCount}} competencies</div>
                    <b-progress :max="childrenCount">
                      <b-progress-bar :value="childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                    </b-progress>
                  </div>

                </div>
              </div>
            </div>

            <program-guide-course-structure :courseStructure="courses" :parentCategory="parentCategory" firstCategory="true" hideCategoryProgress="true" :formattedProgramGuide="formattedProgramGuide" :transactionValidity="transactionValidity" v-if="!userObject.suspended"> </program-guide-course-structure>
          </div>
        </div>

        <template v-if="clickedCourse">
          <b-popover ref="courseStatusPopover" :target="'courseStatusSetting-' + clickedCourse.originUuid" triggers="click" :container="'courseStatusPopup-' + clickedCourse.originUuid" placement="left">
            <div>
              <b-form-group>
                <b-form-radio-group plain stacked v-model="selectedStatus">
                  <template v-for="status in [0, 1, 2, 7]">
                    <b-form-radio class="mt-3" :value="status" @change="closeStatusDropDown(true, status)">
                      <b-button :class="courseStatusBackgroundMap[status]" style="width: 170px;" @click="closeStatusDropDown(true, status)">
                        <div style="color: #fff;">{{courseStatusMap[status]}}</div>
                      </b-button>
                    </b-form-radio>
                  </template>
                </b-form-radio-group>
              </b-form-group>
            </div>
          </b-popover>
        </template>
      </div>
    </div>
  </div>
</template>


<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import ProgramGuideMenu from './ProgramGuideMenu'
  import ProgramCourseScoreAndProgressBar from './ProgramCourseScoreAndProgressBar'
  import ProgramGuideCourseStructure from './ProgramGuideCourseStructure'
  import { StorageFactory } from '../../../storageFactory'
  import { PACKAGE } from '../../../package_constants'
  import VClamp from 'vue-clamp'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-guide-my-program-status',
    props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
    components: {
      ProgramGuideMenu,
      ProgramCourseScoreAndProgressBar,
      ProgramGuideCourseStructure,
      VClamp
    },
    data: () => {
      return {
        courses: [],
        parentCategory : {},
        DEFAULT_TYPE: 'MAJOR',
        DEFAULT_RETURN_TO: 'exploreIntro',
        EXPLORE_RESULTS: 'exploreProgramGuideResults',
        LEARNER_PROGRAM_LIST: 'learnerProgramList',
        userName: localStore.getItem('userFullName'),
        userObject: JSON.parse(localStore.getItem('userobj')),
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        },
        score: 0,
        performance: 0,
        childrenCount: 0,
        totalCourses:0,
        completedCourses:0,
        inprogressCourses:0,
        notStartedCourses:0,
        childrenCompleteCount: 0,
        progressSummaries: [],
        isScoreNotAvailable: true,
        transactionValidity: {}
      }
    },
    beforeMount () {
      this.populatePlanningStreamStructure()
    },
    mounted () {
      this.loadDataForProgramGuideMyStatus()
    },
    methods: {
      ...mapActions([
        'loadProgramGuide',
        'loadStreamWithStructure',
        'updateProgramCourseStatus',
        'loadCheckTransactionValidity',
        'loadStreamWithStructureSummary'

      ]),
      async loadDataForProgramGuideMyStatus () {
        let cipCode = this.cipCode
        let programGuideCode = this.programGuideCode
        let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
        if (!cipCode || !programGuideCode) {
          return this.$router.push({ name: returnTo })
        }
        let programGuide = await this.loadProgramGuide({
          cipCode: cipCode,
          programGuideCode: programGuideCode,
          type: this.programGuideType,
          loadDataFromServer: true
        })
        if (!programGuide || !programGuide.cipCode) {
          return this.$router.push({ name: returnTo })
        }
        this.transactionValidity = await this.loadCheckTransactionValidity(programGuideCode)
      },
      navigateToSelectedProgram (data) {
        let routerParams = {
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.type,
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideIntroduction', params: routerParams})
      },
      resetData () {
        this.score = 0
        this.performance = 0
        this.childrenCount = 0
        this.childrenCompleteCount = 0
        this.courses = []
        this.parentCategory = {}
        this.progressSummaries = [],
        this.isScoreNotAvailable = true
      },
      async populatePlanningStreamStructure () {
        this.resetData()
        await this.loadStreamWithStructure({programCode: this.programGuideCode})
        let structure = this.planningStream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0 && children.length <2) {
            let childStructure = children[0].structure
            this.parentCategory = children[0]
            if (childStructure) {
              let structure = JSON.parse(childStructure)
              this.courses = _.sortBy(structure, 'order')
            }
          }else{
            this.parentCategory = this.planningStream
            let structure1 = JSON.parse(structure)
            this.courses = _.sortBy(structure1, 'order')
          }

          this.totalCourses = this.courses.length

        }
        let summaries = await this.loadStreamWithStructureSummary({programCode: this.programGuideCode})
        for (let i = 0; i < summaries.length; i++) {
            let competencySummary =  summaries[i]
            competencySummary.uuid = this.programGuideCode + '_' + competencySummary.uuid
            this.childrenCount += competencySummary.childrenCount
            this.childrenCompleteCount+= competencySummary.childrenCompleteCount
            if (competencySummary.performance) {
                  console.log('competencySummary.performance '+competencySummary.performance)
                  this.isScoreNotAvailable = false
                  this.performance += competencySummary.performance
                  this.progressSummaries.push(competencySummary)
            }
            if (competencySummary.status ==1) {
                this.inprogressCourses +=1
            }
            if (competencySummary.status ==2) {
                this.completedCourses += 1
            }

        }
        let coursesAndCatalogs = this.getTotalCourseCatalogs(this.courses)
        this.totalCourses = coursesAndCatalogs.length
        this.notStartedCourses = (this.totalCourses - (this.inprogressCourses+this.completedCourses))

        this.notStartedCourses = this.totalCourses - (this.inprogressCourses+this.completedCourses)
        this.score = (this.performance / this.progressSummaries.length).toFixed(2)
        console.log('Total '+this.childrenCount + 'Score ' +this.score)
      },
      returnToClicked () {
        return this.$router.push({ name: this.returnTo })
      },
      deCamelCase () {
        if (!this.returnTo) {
          this.returnTo = this.DEFAULT_RETURN_TO
        }
        if (this.returnTo === this.EXPLORE_RESULTS) {
          return 'return to all results'
        }
        if (this.returnTo === this.LEARNER_PROGRAM_LIST) {
          return 'return to my progress'
        }
        let result = this.returnTo.replace(/([A-Z])/g, ' $1')
        return 'return to ' + result
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      getTotalCourseCatalogs(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getTotalCourseCatalogs(recursionEntities)
                 courses.push(...response)
               }
             }
           } else {
             courses.push(item)
           }

        })

        return courses
      },
      async updateCourseStatus (streamId, status) {
        let data = {
          uuid: streamId,
          status: status
        }
        this.updateProgramCourseStatus(data).then(result => {
          this.populatePlanningStreamStructure()
        })
      },
      openStatusDropDown (course) {
        this.selectedStatus = course.courseStatus
        if (this.clickedCourse) {
          this.closeStatusDropDown(false)
        } else {
          this.clickedCourse = course
          setTimeout(() => {
            this.$refs.courseStatusPopover.$emit('open')
          }, 250)
        }
      },
      closeStatusDropDown (toBeUpdated, status) {
        if (toBeUpdated) {
          this.updateCourseStatus(this.clickedCourse.uuid, status)
        }
        this.clickedCourse = ''
        this.selectedStatus = ''
        this.$refs.courseStatusPopover.$emit('close')
      },
      navigateToCourseDashboard (course) {
        if (course.entityType === 'deliverycontext') {
          this.$store.commit('LOAD_COURSE', {})
          this.$store.commit('LOAD_CLASS_SUMMARY', {})
          this.$store.commit('LOAD_COURSE_TOPICS', {})
          this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
          let courseId = course.originUuid
          return this.$router.push({name: 'courseDashboard', params: {uuid: courseId}})
        }
      },
      aggregateProgressSummary (progressSummary) {
        if ((progressSummary.status === 1) || (progressSummary.status === 2)) {
          this.isScoreNotAvailable = false
          this.progressSummaries.push(progressSummary)
          this.performance += progressSummary.performance
        }
        this.childrenCount += progressSummary.childrenCount
        this.childrenCompleteCount += progressSummary.childrenCompleteCount
        setTimeout(() => {
          this.score = (this.performance / this.progressSummaries.length).toFixed(2)
        }, 1000)
      },
      showMoreDescLnk (id) {
        let entityDescHeight = $('#entityDesc_' + id + ' desc_txt').height()
        if (entityDescHeight > 45) {
          return 'hide_more_link'
        } else {
          return 'show_more_link'
        }
      },
      showMoreDescLink (desc) {
        if(desc){
          desc = desc.replace( /(<([^>]+)>)/ig, '');
        }
        if (desc && desc.length > 101) {
          return true
        } else {
          return false
        }
      },
      showCourseProgress () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      showDesc (fullDesc){
        if(fullDesc){
          let desc = fullDesc.replace( /(<([^>]+)>)/ig, '');
          if(desc.length>101){
            return desc.substring(0,101) + '...'
          }
          return desc;
        }
        return fullDesc
      },

      statusClass (score, hideScore) {
        if (score && !this.isScoreNotAvailable && !hideScore) {
          if (score >= 90) {
            return 'gradeA'
          } else if (score >= 80 && score < 90) {
            return 'gradeB'
          } else if (score >= 65 && score < 80) {
            return 'gradeC'
          } else if (score >= 40 && score < 65) {
            return 'gradeD'
          } else if (score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
      showBarTitle (count, status) {
        if (count > 1) {
          return count + ' courses are ' + status
        } else {
          return count + ' course is ' + status
        }
      }
    },
    computed: {
      ...mapState({
        'planningStream': state => state.dashboard.planningStream,
        'programGuideObject': state => state.programguide.programGuideObject,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'institution': state => state.institution.institution,
        'packages': state => state.institution.packages
      }),
      formattedProgramGuide () {
        let formattedProgramGuide = this.programGuideObject
        return formattedProgramGuide
      },
      programGuideType () {
        let programGuideType = this.type
        if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
          programGuideType = this.DEFAULT_TYPE
        }
        return programGuideType
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideMyProgramStatus.vue